"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function removeLeadingSlash(string) {
  return string.replace(/^\/+/, '');
}

exports.removeLeadingSlash = removeLeadingSlash;

function createCartIdentifier() {
  return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
    return (Math.random() * 16 | 0).toString(16);
  });
}

exports.createCartIdentifier = createCartIdentifier;